<template>
  <div>
    <CHeader :fixed="false" class="py-3">
      <img src="/img/logo-galileo-color-2x.png" alt="" class="mz-logo" />
    </CHeader>
    <div class="open-access-wrapper m-auto">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.path"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenAccess",
};
</script>

<style lang="scss" scoped>
.c-header {
  height: auto;
}

.open-access-wrapper {
  padding-top: 30px;
  max-width: 1220px;
}

.mz-logo {
  height: 50px;
  object-fit: contain;
}

@media (max-width: map-get($grid-breakpoints, "md")) {
  .mz-logo {
    max-width: 100% !important;
    margin-left: 1rem;
  }
  .card {
    margin-bottom: 0;
  }
  .open-access-wrapper {
    padding-top: 0;
  }
}
</style>
